export default "__VITE_ASSET__Dg4jORD3__"